import React, { Component } from 'react';
import styles from './index.css';
import FontFamilyMenu, { FontFamilyMenuProps } from './menu/font-family-menu';
import FontMenu, { FontMenuProps } from './menu/font-menu';
import { hocToolbarItem } from './toolbar-item-hoc';
import classNames from 'classnames';
import { ActionType } from '../../../editor/src/js/constants/common-action-type';
import { SlideSizeType } from '@src/slide/domain/ui-model/element-modeles/property/slide-size/slide-size.interface';
import { autorun, IReactionDisposer } from 'mobx';
import { DropdownType } from '../../../editor/src/js/constants/toolbar-data';
import Dropdown from '@com-pc/dropdown';
import { StyleMode } from '../../../editor/src/js/constants/float-toobbar-data';
import i18n from '@i18next/i18n';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';


const Content = item => (
    <React.Fragment>
        <div className={classNames({
            [styles.title]: true,
            [styles.fontFamily]: item.id === ActionType.FONT,
            [styles.fontSize]: item.id === ActionType.FONTSIZE,
        })}>
            {item.content}
        </div>
    </React.Fragment>
);

type DropContentProps = {
    type: string;
} & (FontFamilyMenuProps | FontMenuProps);

const DropContent: React.FC<DropContentProps> = ({ type, ...props }) => (
    type === DropdownType.FONT_FAMILY ? <FontFamilyMenu {...props} />
        : <FontMenu {...props as FontMenuProps} />
);

interface ToolbarItemTextProps {
    id: string;
    content: string;
    value: any;
    disabled: boolean;
    dropdown: {
        data: any[];
        checkSelectedValue: boolean;
        type: string;
    };
    model: typeof StyleMode[keyof typeof StyleMode];
    keyIndex?: number;
    showSelectedValue?: boolean;
    handleClick: (id: string, value: any) => void;
}

interface ToolbarItemTextState {
    selectedIndex: number;
    selectedValue: any;
    selected: boolean;
}
const ItemComponent = hocToolbarItem(Content);
export default class ToolbarItemText extends Component<ToolbarItemTextProps, ToolbarItemTextState> {
    private autorun?: IReactionDisposer;
    private num: number;
    private dropDom: Dropdown | null;
    public constructor(props: ToolbarItemTextProps) {
        super(props);
        this.state = {
            selectedIndex: -1,
            selectedValue: null,
            selected: false,
            ...this.getInitialState(props),
        };
    }

    public componentDidMount() {
        this.autorun = autorun(() => {
            const num = this.getMenuManager()?.hideAllMenuNum;
            const isOtherMenuShown = this.getMenuManager()?.isMenuShown || this.num !== num;
            this.num = Number(num);
            if (this.state.selected && isOtherMenuShown) {
                this.setState({ selected: false });
                this.hideDropDown();
            }
        });
    }

    public componentWillUnmount() {
        if (this.autorun) {
            this.autorun();
        }
    }
    // eslint-disable-next-line react/no-deprecated
    public componentWillReceiveProps(nextProps: ToolbarItemTextProps) {
        if (nextProps.id === ActionType.SLIDE_SIZE) { // 幻灯片设置在显示时更新
            return;
        }
        let index = -1;
        if (this.hasDropdown(nextProps) && nextProps.dropdown.checkSelectedValue) {
            nextProps.dropdown.data.forEach((item, i) => {
                if (nextProps.value === item.id || (item.content && nextProps.value === item.content)) {
                    index = i;
                }
            });
        }

        let value = nextProps.value || '';
        if (index < 0) {
            if (nextProps.id === ActionType.FONTSIZE) {
                // 从val里找出数字... 'font-size-xxpt' -> 'xx'
                const n = value.match(/([0-9]+([.]{1}[0-9]+){0,1})\+?/);
                if (!n) {
                    value = '';
                } else {
                    value = n[0];
                }
            } else if (nextProps.id === ActionType.FONT && value === 'multi') {
                value = i18n.t('多种字体');
            }
        }
        this.setState({ selectedIndex: index, selectedValue: value });
    }


    public render() {
        const isQuickModel = this.props.model === StyleMode.QUICK_SETTING;
        const idPreFix = isQuickModel ? (`${StyleMode.QUICK_SETTING + (this.props.keyIndex || 0)}-`) : '';

        if (this.hasDropdown(this.props)) {
            return (
                <React.Fragment>
                    <ItemComponent
                        {...this.props}
                        idPreFix={idPreFix}
                        selected={this.state.selected}
                        content={this.getDisplayContent()}
                        handleClick={() => {}}
                    />
                    <Dropdown belongID={`${idPreFix}toolbar-${this.props.id}`} shadowType="menu" ref={(ref) => {
                        this.dropDom = ref;
                    }}
                    onVisibleChange={this.handleMenuVisibleChange} autoAlign={isQuickModel}>
                        {this.getDropContent()}
                    </Dropdown>
                </React.Fragment>

            );
        }
        return (
            <ItemComponent {...this.props} idPreFix={idPreFix}/>
        );
    }

    private hasDropdown(props: ToolbarItemTextProps): boolean {
        if (props.dropdown?.data && props.dropdown.data.length > 0 && !props.disabled) {
            return true;
        }
        return false;
    }


    // eslint-disable-next-line complexity
    private getInitialState(props: ToolbarItemTextProps) {
        let index = -1;
        if (props.id === ActionType.SLIDE_SIZE) { // 幻灯片设置
            if (props.dropdown.checkSelectedValue) {
                let index = -1;
                const { slideSizeType } = this.getUiDataService().presentation.props;
                if (slideSizeType === SlideSizeType.SLIDE_SIZE_4_3) {
                    index = 0;
                } else if (slideSizeType === SlideSizeType.SLIDE_SIZE_16_9) {
                    index = 1;
                }
                return { selectedIndex: index };
            }
        } else {
            if (this.hasDropdown(props) && props.dropdown.checkSelectedValue) {
                props.dropdown.data.forEach((item, i) => {
                    if (props.value === item.id || (item.content && props.value === item.content)) {
                        index = i;
                    }
                });
            }

            let value = props.value || '';
            if (index < 0) {
                if (props.id === ActionType.FONTSIZE) {
                    // 从val里找出数字... 'font-size-xxpt' -> 'xx'
                    const n = value.match(/([0-9]+([.]{1}[0-9]+){0,1})\+?/);
                    if (!n) {
                        value = '';
                    } else {
                        value = n[0];
                    }
                } else if (props.id === ActionType.FONT && value === 'multi') {
                    value = i18n.t('多种字体');
                }
            }
            return { selectedIndex: index, selectedValue: value };
        }
    }

    private handleMenuClick = (index: number) => {
        const itemData = this.props.dropdown.data[index];
        this.props.handleClick(this.props.id, itemData.id);
        // this.setState({ selectedIndex: index });
        this.hideDropDown();
    };

    private getDisplayContent(): string {
        let displayContent = this.state.selectedValue || this.props.content || '';
        if (this.props.id === ActionType.SLIDE_SIZE) { // 幻灯片设置
            displayContent = this.props.content;
        } else if (this.hasDropdown(this.props) && this.state.selectedIndex >= 0
      && this.props.showSelectedValue === true) {
            const itemData = this.props.dropdown.data[this.state.selectedIndex];
            displayContent = itemData.content;
        }
        return i18n.t(displayContent);
    }

    private getDropContent() {
        return (
            <DropContent
                key={`toolbar_menu_${this.props.id}`}
                {...this.props.dropdown}
                selectedIndex={this.state.selectedIndex}
                onMenuClick={this.handleMenuClick}
            />
        );
    }

    private handleMenuVisibleChange = (visible: boolean) => {
        if (this.hasDropdown(this.props)) {
            this.setState({ selected: visible });
            if (visible) {
                this.beforeDropDownShow();
            }
        }
        if (visible) {
            setTimeout(() => { // 延迟一下，确保左右切换菜单时状态正确
                this.getToolbarStateManager().isToolbarMenuShown = true;
            }, 50);
        } else {
            this.getToolbarStateManager().isToolbarMenuShown = false;
        }
    };

    private beforeDropDownShow = () => {
        if (this.props.id === ActionType.SLIDE_SIZE) { // 幻灯片设置
            if (this.props.dropdown.checkSelectedValue) {
                let index = -1;
                const { slideSizeType } = this.getUiDataService().presentation.props;
                if (slideSizeType === SlideSizeType.SLIDE_SIZE_4_3) {
                    index = 0;
                } else if (slideSizeType === SlideSizeType.SLIDE_SIZE_16_9) {
                    index = 1;
                }
                this.setState({ selectedIndex: index });
            }
        }
    };

    private hideDropDown = () => {
        if (this.dropDom) {
            this.dropDom.hide();
        }
    };

    private getUiDataService() {
        return this.getAppService().getUiDataService();
    }

    private getMenuManager() {
        return this.getAppService().editableServiceLayer?.menuManager;
    }

    private getToolbarStateManager = () => this.getAppService().viewableServiceLayer.toolbarStateManager;

    private getAppService() {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }
}
